const rsAstralRange = '\\ud800-\\udfff';
const rsComboMarksRange = '\\u0300-\\u036f';
const reComboHalfMarksRange = '\\ufe20-\\ufe2f';
const rsComboSymbolsRange = '\\u20d0-\\u20ff';
const rsComboMarksExtendedRange = '\\u1ab0-\\u1aff';
const rsComboMarksSupplementRange = '\\u1dc0-\\u1dff';
const rsComboRange = rsComboMarksRange +
    reComboHalfMarksRange +
    rsComboSymbolsRange +
    rsComboMarksExtendedRange +
    rsComboMarksSupplementRange;
const rsVarRange = '\\ufe0e\\ufe0f';
const rsZWJ = '\\u200d';
const reHasUnicode = RegExp(`[${rsZWJ + rsAstralRange + rsComboRange + rsVarRange}]`);
/**
 * Проверяет, есть ли в переданной строке юникодные символы.
 *
 * @param stringParam Строка
 * @returns true, если в переданной строке есть юникодные символы, иначе false
 *
 * @example
 * ```typescript
 * import { hasUnicode } from '@direct-frontend/stdlib';
 *
 * hasUnicode('string\u200dstring'); // true
 * ```
 */
export function hasUnicode(stringParam) {
    return reHasUnicode.test(stringParam);
}
